export const DRAG_START = 'SCHEDULE/DRAG_START';
export const DRAG_END = 'SCHEDULE/DRAG_END';
export const SET_TIMESPAN = 'SCHEDULE/SET_TIMESPAN';
export const SET_DRAG_POSITION = 'SCHEDULE/SET_DRAG_POSITION';
export const START_CREATE = 'SCHEDULE/START_CREATE';
export const END_CREATE = 'SCHEDULE/END_CREATE';
export const SELECT_ITEM = 'SCHEDULE/SELECT_ITEM';
export const REQUEST_SCHEDULE = 'SCHEDULE/REQUEST_SCHEDULE';
export const RECEIVE_SCHEDULE = 'SCHEDULE/RECEIVE_SCHEDULE';
export const START_CHANGE_TIMESPAN = 'SCHEDULE/START_CHANGE_TIMESPAN';
export const END_CHANGE_TIMESPAN = 'SCHEDULE/END_CHANGE_TIMESPAN';
export const REQUEST_SAVE_SCHEDULE = 'SCHEDULE/REQUEST_SAVE_SCHEDULE';
export const RECEIVE_SAVE_SCHEDULE = 'SCHEDULE/RECEIVE_SAVE_SCHEDULE';
export const ADD_TRACK = 'SCHEDULES/ADD_TRACK';
export const UPDATE_FILTER = 'SCHEDULES/UPDATE_FILTER';
export const REMOVE_ITEM = 'SCHEDULES/REMOVE_ITEM';
export const UPDATING = 'SCHEDULES/UPDATING';
export const SET_UNSUBSCRIBE_HANDLER = 'SCHEDULES/SET_UNSUBSCRIBE_HANDLER';